interface SideBarProps {
	link: string;
	name: string;
	isIndex?: boolean;
	isTs?: boolean;
	isJs?: boolean;
}

export const SideBarData: SideBarProps[] = [
	{
		link: '/playground',
		name: 'Playground',
	},
	{
		link: '/use-reducer',
		name: 'Use Reducer',
	},
	{
		link: '/use-memo-two',
		name: 'Use Memo Two',
	},
	{
		link: '/react-memo',
		name: 'React Memo',
	},
	{
		link: '/use-transition',
		name: 'Use Transition',
	},
	{
		link: '/use-memo',
		name: 'Use Memo',
	},
	{
		link: '/use-callback',
		name: 'Use Callback',
	},
	{
		link: '/lazy-image-load',
		name: 'Lazy Image Load',
	},
	{
		link: '/infinity-scroll',
		name: 'Infinity Scroll',
	},
	{
		link: '/infinity-scroll-two',
		name: 'Infinity Scroll Two',
	},
	{
		link: '/debounce-input',
		name: 'Debounce Input',
	},
	{
		link: '/react-query',
		name: 'React Query',
	},
	{
		link: '/typescript',
		name: 'Typescript',
		isTs: true,
	},
	{
		link: '/js-arrays',
		name: 'Javascript',
		isJs: true,
	},
	{
		link: '/use-click-outside',
		name: 'Use Click Outside',
	},
	// {
	// 	link: '/other-page',
	// 	name: 'Error Boundary',
	// },
];
